import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { Dialog, DialogContent } from 'components/ui/dialog';

import { SignAgreementFormContainer } from './Container';

export const SendAgreementModal: React.FC = () => {
  const {
    isSendAgreementModalOpen,
    setIsSendAgreementModalOpen,
    toggleChecklistExpandedState
  } = useChecklistState();

  const handleClose = () => {
    setIsSendAgreementModalOpen(false);
    toggleChecklistExpandedState(false);
  };

  return (
    <Dialog open={isSendAgreementModalOpen} onOpenChange={handleClose}>
      <DialogContent
        className="w-[42vw] max-w-[480px] h-[277px] px-6 py-9 bg-white mx-auto"
        showCloseButton
      >
        <SignAgreementFormContainer />
      </DialogContent>
    </Dialog>
  );
};
